"use client";

import Link from "next/link";
import FollowUs from "@/app/(components)/generics/FollowUs/FollowUs";
import Logo from "@/app/(components)/generics/Logo/Logo";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { DefaultProps } from "@/app/types/common/DefaultProps";
import { Globals } from "@/app/vars/Globals";
import { FOOTER_SECTIONS } from "./Footer.logic";
import styles from "./Footer.module.css";

export default function Footer(props: DefaultProps) {
  const T = useT();
  const { params } = props;
  const { lang } = params;

  return (
    <footer className={styles.container}>
      <div className={styles.content}>
        <div className={styles.top}>
          <div className={styles.brand}>
            <Logo light={true} flush={true} className={styles.brandLogo} />
            <p className={styles.tagline}>{T(TKey.FOOTER_TAGLINE)}</p>
            <div className={styles.socials}>
              <FollowUs />
            </div>
          </div>

          <div className={styles.columns}>
            {FOOTER_SECTIONS.map((section) => (
              <nav key={section.titleKey} className={styles.column}>
                <p className={styles.columnTitle}>{T(section.titleKey)}</p>
                <ul className={styles.links}>
                  {section.links.map((link) => (
                    <li key={link.path}>
                      <Link className={styles.link} href={`/${lang}${link.path}`}>
                        {T(link.labelKey)}
                      </Link>
                    </li>
                  ))}
                </ul>
              </nav>
            ))}
          </div>
        </div>

        <div className={styles.separator} />

        <p className={styles.copy}>
          {Globals.COMPANY.NAME} © {new Date().getFullYear()}
        </p>
      </div>
    </footer>
  );
}
